import { Button } from "@mui/material";
import React, { useState } from "react";
import Dash from "../Dash";
import CustomModal from "../Modal";
import Table from "../Table";

const IncentiveTable = ({ data, staffId, type }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [activeTable, setActiveTable] = useState(null);
  const [activeIncentiveType, setActiveIncentiveType] = useState(null);

  const handleViewRecords = (item) => {
    setSelectedRecord(item);
    setIsModalOpen(true);
  };

  const handleDashClick = (type) => {
    setActiveTable(type);
    // Set Order Incentive as default when incentivesAmount is selected
    if (type === "incentivesAmount") {
      setActiveIncentiveType("Order Incentive");
    } else {
      setActiveIncentiveType(null);
    }
  };

  const handleIncentiveTypeClick = (incentiveType) => {
    setActiveIncentiveType(incentiveType);
  };

  const getTableData = () => {
    switch (activeTable) {
      case "incentiveCredit":
        return data?.incentiveCreditList || [];
      case "incentivesAmount":
        const incentiveData = data?.incentive || [];
        // If an incentive type filter is active, filter the data
        if (activeIncentiveType) {
          return incentiveData.filter(
            (item) => item.incentiveType === activeIncentiveType
          );
        }
        return incentiveData;
      case "lockedIncentive":
        return data?.incentiveLockedList || [];
      default:
        return [];
    }
  };

  const getTableColumns = () => {
    const viewRecordsColumn = {
      title: "View Records",
      render: (item) => (
        <Button
          variant="contained"
          size="small"
          onClick={() => handleViewRecords(item)}
        >
          View Records
        </Button>
      ),
    };

    switch (activeTable) {
      case "incentiveCredit":
        return [
          {
            title: "Date",
            dataIndex: "date",
            render(item) {
              return new Date(item?.date)
                ?.toISOString()
                ?.replace(/T.*/, "")
                ?.split("-")
                ?.reverse()
                ?.join("-");
            },
          },
          {
            title: "Amount",
            dataIndex: "amount",
            render(item) {
              return item?.amount?.toFixed(2);
            },
          },
          {
            title: "Description",
            dataIndex: "description",
          },
          {
            title: "Completed By",
            dataIndex: "completedByName",
          },
          viewRecordsColumn,
          {
            title: "PDF",
            link: `/admin/staff/incentive/${staffId}?type=${activeTable}`,
          },
        ];
      case "incentivesAmount":
        return [
          {
            title: "Date",
            dataIndex: "createdAt",
            render(item) {
              return new Date(item?.createdAt)
                ?.toISOString()
                ?.replace(/T.*/, "")
                ?.split("-")
                ?.reverse()
                ?.join("-");
            },
          },
          {
            title: "Customer",
            accessor: "customer",
            render(item) {
              return (
                item?.customer?.userName ?? item?.order?.customer?.userName
              );
            },
          },
          type === "staff" || activeIncentiveType === "Customer Incentive"
            ? null
            : {
                title: "Product",
                dataIndex: "product",
                render(item) {
                  return item?.order?.product?.productName;
                },
              },

          type === "staff" || activeIncentiveType === "Customer Incentive"
            ? null
            : {
                title: "Order Quantity",
                dataIndex: "orderQuantity",
                render(item) {
                  return item?.order?.quantity;
                },
              },
          {
            title: "Amount",
            dataIndex: "amount",
            render(item) {
              return item?.amount?.toFixed(2);
            },
          },
          viewRecordsColumn,
          {
            title: "PDF",
            link: `/admin/staff/incentive/${staffId}?type=${activeTable}&incentiveType=${activeIncentiveType}`,
          },
        ];
      case "lockedIncentive":
        return [
          {
            title: "Date",
            dataIndex: "createdAt",
            render(item) {
              return new Date(item?.createdAt)
                ?.toISOString()
                ?.replace(/T.*/, "")
                ?.split("-")
                ?.reverse()
                ?.join("-");
            },
          },
          type === "staff"
            ? null
            : {
                title: "Customer",
                accessor: "customer",
                render(item) {
                  return (
                    item?.customer?.userName ?? item?.order?.customer?.userName
                  );
                },
              },

          type === "staff"
            ? null
            : {
                title: "Product",
                dataIndex: "product",
                render(item) {
                  return item?.order?.product?.productName;
                },
              },

          type === "staff"
            ? null
            : {
                title: "Order Quantity",
                dataIndex: "orderQuantity",
                render(item) {
                  return item?.order?.quantity;
                },
              },

          {
            title: "Type",
            dataIndex: "incentiveType",
          },
          {
            title: "Pending Amount",
            dataIndex: "locked",
            render(item) {
              return item?.locked?.toFixed(2);
            },
          },
          viewRecordsColumn,
          {
            title: "PDF",
            link: `/admin/staff/incentive/${staffId}?type=${activeTable}&user=staff`,
          },
        ];
      default:
        return [];
    }
  };

  return (
    <div className="flex flex-col gap-10">
      <div className="grid grid-cols-4 gap-4">
        <button
          onClick={() => handleDashClick("lockedIncentive")}
          className="w-full"
        >
          <Dash
            title={"INCENTIVE PENDING FOR CUSTOMERS"}
            value={data?.lockedIncentive?.toFixed(2)}
          />
        </button>
        <button
          onClick={() => handleDashClick("incentivesAmount")}
          className="w-full"
        >
          <Dash
            title={"INCENTIVE RECEIVED BY CUSTOMERS"}
            value={data?.incentivesAmount?.toFixed(2)}
          />
        </button>
        <button
          onClick={() => handleDashClick("incentiveCredit")}
          className="w-full"
        >
          <Dash
            title={`INCENTIVE PAYMENT ${
              type === "staff" ? "RECEIVED BY ADMIN" : "FOR STAFF"
            }`}
            value={data?.incentiveCredit?.toFixed(2)}
          />
        </button>
        <button className="w-full">
          <Dash
            title={`INCENTIVE PAYMENT PENDING ${
              type === "staff" ? "FOR ADMIN" : "FOR STAFF"
            }`}
            value={(
              data?.incentivesAmount?.toFixed(2) -
              data?.incentiveCredit?.toFixed(2)
            )?.toFixed(2)}
          />
        </button>
      </div>
      <div className="flex flex-col gap-4 ">
        {activeTable === "incentivesAmount" && (
          <div className="flex gap-4 ">
            <Button
              variant={
                activeIncentiveType === "Order Incentive"
                  ? "contained"
                  : "outlined"
              }
              onClick={() => handleIncentiveTypeClick("Order Incentive")}
            >
              Order Incentive
            </Button>
            <Button
              onClick={() => handleIncentiveTypeClick("Customer Incentive")}
              variant={
                activeIncentiveType === "Customer Incentive"
                  ? "contained"
                  : "outlined"
              }
            >
              Customer Incentive
            </Button>
          </div>
        )}

        {activeTable && (
          <Table
            data={getTableData()}
            rowClassName={(item) => {
              return item?.type === "Incentive Credit"
                ? "bg-green-600 text-white"
                : "";
            }}
            columns={getTableColumns()}
          />
        )}
      </div>
      {/* Records Modal */}
      <CustomModal
        open={isModalOpen}
        setOpen={setIsModalOpen}
        title="Record History"
        button={<></>}
        width="md:w-[50rem]"
      >
        {selectedRecord && (
          <div className="flex flex-col gap-4">
            {selectedRecord.record && selectedRecord.record.length > 0 ? (
              <Table
                data={selectedRecord.record}
                columns={[
                  {
                    title: "Date",
                    dataIndex: "date",
                  },
                  {
                    title: "Incentive Type",
                    dataIndex: "incentiveType",
                  },
                  {
                    title: "Amount",
                    dataIndex: "amount",
                  },
                  {
                    title: "Locked",
                    dataIndex: "locked",
                  },
                  {
                    title: "Message",
                    dataIndex: "message",
                  },
                ]}
              />
            ) : (
              <p>No record history available</p>
            )}
          </div>
        )}
      </CustomModal>
    </div>
  );
};

export default IncentiveTable;
